/**
 * Стили фотореалистичной визуализации помещения. Название — для прораба и
 * заказчика, описание — для нейросети: модели точнее следуют английскому
 * описанию материалов, чем названию стиля.
 */
export const RENDER_STYLES = [
    {
        code: 'scandinavian',
        label: 'Скандинавский',
        prompt: 'Scandinavian style: light oak wood, white and warm grey tones, cozy textiles, a few green plants, soft daylight',
    },
    {
        code: 'modern',
        label: 'Современный',
        prompt: 'modern contemporary style: clean lines, neutral palette with one accent colour, sleek furniture, hidden lighting',
    },
    {
        code: 'minimal',
        label: 'Минимализм',
        prompt: 'minimalist style: very few pieces of furniture, monochrome palette, no clutter, clean surfaces',
    },
    {
        code: 'loft',
        label: 'Лофт',
        prompt: 'industrial loft style: dark metal accents, leather sofa, exposed textures, pendant lamps, warm lighting',
    },
    {
        code: 'classic',
        label: 'Современная классика',
        prompt: 'modern classic style: wall mouldings, elegant upholstered furniture, brass details, soft beige and cream palette',
    },
    {
        code: 'eco',
        label: 'Эко',
        prompt: 'eco style: natural wood, linen, rattan and stone, earthy colours, many plants, lots of natural light',
    },
];
export const RENDER_STYLE_CODES = RENDER_STYLES.map((s) => s.code);
//# sourceMappingURL=render-styles.js.map